const singlePackagePrice = 19.99
const singlePackageDiscountedPrice = 14.99
const multiPackagePrice = 29.99
const multiPackageDiscountedPrice = 24.99

export const fanduelPackages = {
  'DETROIT ONLY': {
    offerCode: 'us-rc-ga-fanduel_det-mo-5d-5a1-1',
    price: singlePackagePrice,
    discountedPrice: singlePackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_det-mo-nt-10a1-1',
  },
  'FLORIDA + SUN': {
    offerCode: 'us-rc-ga-fanduel_florida_sun-mo-5d-5a1-1',
    price: multiPackagePrice,
    discountedPrice: multiPackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_florida_sun-mo-nt-10a1-1',
  },
  'MIDWEST + NORTH': {
    offerCode: 'us-rc-ga-fanduel_mw_n-mo-5d-5a1-1',
    price: multiPackagePrice,
    discountedPrice: multiPackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_mw_n-mo-nt-10a1-1',
  },
  'MIDWEST + OHIO': {
    offerCode: 'us-rc-ga-fanduel_mw_oh-mo-5d-5a1-1',
    redsOfferCode: 'us-rc-mk-fanduel_mw_oh_reds-mo-7d-5a1-1',
    price: multiPackagePrice,
    discountedPrice: multiPackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_mw_oh-mo-nt-10a1-1',
  },
  'MIDWEST ONLY': {
    offerCode: 'us-rc-ga-fanduel_mw-mo-5d-5a1-1',
    price: singlePackagePrice,
    discountedPrice: singlePackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_mw-mo-nt-10a1-1',
  },
  'NORTH ONLY': {
    offerCode: 'us-rc-ga-fanduel_n-mo-5d-5a1-1',
    price: singlePackagePrice,
    discountedPrice: singlePackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_n-mo-nt-10a1-1',
  },
  'OHIO + DETROIT': {
    offerCode: 'us-rc-ga-fanduel_oh_det-mo-5d-5a1-1',
    redsOfferCode: 'us-rc-mk-fanduel_oh_det_reds-mo-7d-5a1-1',
    price: multiPackagePrice,
    discountedPrice: multiPackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_oh_det-mo-nt-10a1-1',
  },
  'OHIO + SOUTH + SOUTHEAST': {
    offerCode: 'us-rc-ga-fanduel_oh_s_se-mo-5d-5a1-1',
    redsOfferCode: 'us-rc-mk-fanduel_oh_s_se_reds-mo-7d-5a1-1',
    price: multiPackagePrice,
    discountedPrice: multiPackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_oh_s_se-mo-nt-10a1-1',
  },
  'OHIO + SOUTH': {
    offerCode: 'us-rc-ga-fanduel_oh_s-mo-5d-5a1-1',
    redsOfferCode: 'us-rc-mk-fanduel_oh_s_reds-mo-7d-5a1-1',
    price: multiPackagePrice,
    discountedPrice: multiPackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_oh_s-mo-nt-10a1-1',
  },
  'OHIO ONLY': {
    offerCode: 'us-rc-ga-fanduel_oh-mo-5d-5a1-1',
    redsOfferCode: 'us-rc-mk-fanduel_oh_reds-mo-7d-5a1-1',
    price: singlePackagePrice,
    discountedPrice: singlePackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_oh-mo-nt-10a1-1',
  },
  'OKLAHOMA ONLY': {
    offerCode: 'us-rc-ga-fanduel_ok-mo-5d-5a1-1',
    price: singlePackagePrice,
    discountedPrice: singlePackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_ok-mo-nt-10a1-1',
  },
  'SOCAL + WEST': {
    offerCode: 'us-rc-ga-fanduel_sc_ws-mo-5d-5a1-1',
    price: multiPackagePrice,
    discountedPrice: multiPackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_sc_ws-mo-nt-10a1-1',
  },
  'SOUTH + SOUTHEAST': {
    offerCode: 'us-rc-ga-fanduel_s_se-mo-5d-5a1-1',
    redsOfferCode: 'us-rc-mk-fanduel_s_se_reds-mo-7d-5a1-1',
    price: multiPackagePrice,
    discountedPrice: multiPackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_s_se-mo-nt-10a1-1',
  },
  'SOUTH ONLY': {
    offerCode: 'us-rc-ga-fanduel_s-mo-mo-5d-5a1-1',
    price: singlePackagePrice,
    discountedPrice: singlePackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_s-mo-mo-nt-10a1-1',
  },
  'SOUTHWEST ONLY': {
    offerCode: 'us-rc-ga-fanduel_sw-mo-5d-5a1-1',
    price: singlePackagePrice,
    discountedPrice: singlePackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_sw-mo-nt-10a1-1',
  },
  'WEST ONLY': {
    offerCode: 'us-rc-ga-fanduel_w-mo-5d-5a1-1',
    price: singlePackagePrice,
    discountedPrice: singlePackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_w-mo-nt-10a1-1',
  },
  'WISCONSIN ONLY': {
    offerCode: 'us-rc-ga-fanduel_wi-mo-5d-5a1-1',
    price: singlePackagePrice,
    discountedPrice: singlePackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_wi-mo-nt-10a1-1',
  },
  'NORTH + WISCONSIN': {
    offerCode: 'us-rc-ga-fanduel_n_wi-mo-5d-5a1-1',
    price: multiPackagePrice,
    discountedPrice: multiPackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_n_wi-mo-nt-10a1-1',
  },
  'SOUTH + SOUTHEAST + SOUTHWEST': {
    offerCode: 'us-rc-ga-fanduel_s_se_sw-mo-5d-5a1-1',
    redsOfferCode: 'us-rc-mk-fanduel_s_se_sw_reds-mo-7d-5a1-1',
    price: multiPackagePrice,
    discountedPrice: multiPackageDiscountedPrice,
    winbackOfferCode: 'us-rc-wb-fanduel_s_se_sw-mo-nt-10a1-1',
  },
}
